module.exports = __webpack_public_path__ + "img/miscIcon.f96da9c2.png";